var TimelineInit;

(function ($) {

	const selectors = {
		wrapper: '[data-timeline]',
		link: '[data-timeline-link]',
		content: '[data-timeline-content-box]',
	}

	TimelineInit = function () {
		$(selectors.wrapper).each((i, el) => {
			new Timeline(el);
		})
	}

	class Timeline {

		constructor(wrapper) {

			this.$wrapper = $(wrapper);

			if (this.$wrapper.length) {
				this.init();
			}

		}

		init() {

			this.$links = $(selectors.link, this.$wrapper);
			this.$content = $(selectors.content, this.$wrapper);

			this.bind();

			this.showBox(0);

		}
		bind() {
			const self = this;

			self.onLinkClicked = self.onLinkClicked.bind(self);
			self.$links.click(function () { self.onLinkClicked(this); });


		}

		onLinkClicked(link) {

			const self = this;
			const $link = $(link)

			const box_idx = $link.attr('data-idx');

			if (box_idx) {
				self.showBox(box_idx);
			}

		}

		showBox(box_idx) {

			const self = this;
			const $box = self.$content.filter('[data-idx="' + box_idx + '"]');
			const $link = self.$links.filter('[data-idx="' + box_idx + '"]');

			if ($box.hasClass('is-visible')) {
				return;
			}

			self.$content.not($box).removeClass('visible');
			self.$content.not($box).filter(':visible').stop().fadeOut();
			$box.addClass('visible').stop().fadeIn();

			self.$links.not($link).removeClass('is-active');
			$link.addClass('is-active');

		}

	}

})(jQuery);


export default TimelineInit;